// extracted by mini-css-extract-plugin
export var cancelButton = "_od-5";
export var content = "_od-3";
export var createButton = "_od-6";
export var drawerContainer = "_od-0";
export var footer = "_od-2";
export var header = "_od-1";
export var orderFormColumn = "_od-4";